module.exports = __webpack_public_path__ + "img/third_login_loading.c07ef9e2.gif";